var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-form',{ref:"productForm",attrs:{"supplier-id":_vm.supplierId,"sku":_vm.sku,"back-to":_vm.backTo,"title":((_vm.isEdit ? 'Edit' : 'Create') + " Supplier Product"),"is-edit":_vm.isEdit,"type":"supplier"}})}
var staticRenderFns = []

export { render, staticRenderFns }